import i18n from "i18n-js";
import fr from "./locales/fr.json";

const avalaibleLocales: string[] = ["fr"];

i18n.defaultLocale = "fr";
i18n.locale = "fr";
i18n.fallbacks = true;
i18n.translations = { fr };

class Language {
    private static instance: Language;

    public locale: string = "fr";

    public static getInstance(): Language {
        if (!Language.instance) {
            Language.instance = new Language();
        }

        return Language.instance;
    }

    public labels = () => {
        let localizationFile = this.locale === "fr" ? fr : fr; // Si on ne connait pas la langue, on la met en anglais   
        return fr;
    }

    public translate = (label: string, variables?: { [key: string]: string }) => {
        let labelToReturn: string = label;
        for (const aVariableKey in variables) {
            if (Object.prototype.hasOwnProperty.call(variables, aVariableKey)) {
                const aVariable: string = variables[aVariableKey];
                labelToReturn = labelToReturn.replace("%{" + aVariableKey + "}", aVariable);
            }
        }
        return labelToReturn;
    }

    public t = (key: string) => {
        let localizationFile = this.locale === "fr" ? fr : fr;
        let keysArray: string[] = key.split(".");
        let labelToReturn: string | string[] = "";
        for (const keysArrayIndex in keysArray) {
            if (Object.prototype.hasOwnProperty.call(keysArray, keysArrayIndex)) {
                const element = keysArray[keysArrayIndex];
                if (parseInt(keysArrayIndex) === 0) {
                    labelToReturn = localizationFile[element];
                } else {
                    labelToReturn = labelToReturn[element];
                }
            }
        }
        if (labelToReturn.length > 0) {
            return labelToReturn;
        } else {
            return "unknwonw";
        }
    }
}

export function getLanguage() {
    const availableLanguages = ["fr"];
    let deviceLanguage = "fr";

    return deviceLanguage;
}

export const translate = Language.getInstance();

export default i18n;